const initState = {
  loading: false,
  addLoading: false,
  updateLoading: false,
  deleteLoading: false,
  deleteCatalogLoading: false,
  getLoading: false,
  catalogs: [],
  currentPageCatalog: 1,
};

const catalogReducer = (state = initState, action) => {
  switch (action.type) {
    case "GET_CATALOGS":
      return {
        ...state,
        catalogs: action.payload,
      };
    case "GET_CATALOGS_PAGES":
      return {
        ...state,
        currentPageCatalog: action.payload,
      };
    case "ADD_CATALOG_LOADER":
      return {
        ...state,
        addLoading: action.payload,
      };
    case "UPDATE_CATALOG_LOADER":
      return {
        ...state,
        updateLoading: action.payload,
      };
    case "DELETE_CATALOG_LOADER":
      return {
        ...state,
        deleteLoading: action.payload,
      };
    case "DELETE_CATALOG_LOADING":
      return {
        ...state,
        deleteCatalogLoading: action.payload,
      };
    case "GET_CATALOG_LOADER":
      return {
        ...state,
        getLoading: action.payload,
      };
    default:
      return state;
  }
};

export default catalogReducer;
